import styled from '@emotion/styled'
import { SelectableOptionsPopover } from '~/components/SelectableOptionsPopover'

export const SortSelect = styled(SelectableOptionsPopover)`
  margin-left: 0.25rem;
`
